export class LegalAdDisplayFile {
    public fileName: string;
    public uploadDate: Date;
    public authorName: string;
    public fileGuid: string;
    public file: File;
    public fileURI: string;
}